module.exports = __webpack_public_path__ + "static/imagen_08-ba4d77caae0155e6819bf7be5545d263.jpg";